/* eslint-disable prefer-rest-params */
export default function preload (src) {
	const preloadNode = document.querySelector('#preload');

	for (let i = 0; i < arguments.length; i++) {
		const video = new Image();
		video.src = src;

		const videoNode = document.createElement('video');
		const source = document.createElement('source');
		source.src = src;
		source.preload = 'auto';
		source.type = 'video/mp4';
		videoNode.appendChild(source);
		preloadNode.appendChild(videoNode);
	}
}
